


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const customerFileReducer = function(state = initialState, action) {
switch (action.type) {
case Actions.CUSTOMER_FILE_SUBMISSION:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.CUSTOMER_FILE_SUBMISSION_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.CUSTOMER_FILE_SUBMISSION_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
